export default "__VITE_ASSET__33b910a2__"